import { render, staticRenderFns } from "./editChain.vue?vue&type=template&id=ceafb1f8"
import script from "./editChain.vue?vue&type=script&lang=js"
export * from "./editChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports